import { put, takeEvery, takeLatest, call } from '@redux-saga/core/effects';
import {
  delete_product_from_basket,
  delete_product_from_basket_success,
  delete_product_from_basket_error,
  update_basket_quantity,
  update_basket_quantity_error,
  update_basket_quantity_success,
  apply_coupon,
  apply_coupon_error,
  apply_coupon_success,
  get_user_basket,
  get_user_basket_success,
  get_user_basket_error,
  get_user_products,
  get_user_products_success,
  get_user_products_error,
  get_partner_config,
  get_partner_config_success,
  get_partner_config_error,
  get_delivery_location,
  get_delivery_location_success,
  get_delivery_location_error,
  get_customer_basket,
  get_customer_basket_success,
  get_customer_basket_error,
  add_product,
  add_product_success,
  add_product_error,
} from './reducer';
import api from '@service/DataService';
import toast from 'react-hot-toast';

function* applyCouponSaga({ payload }) {
  try {
    const requestRes = yield call(api.patch, `/baskets/applyCoupon`, payload);
    const responseData = requestRes.data;
    yield put({
      type: apply_coupon_success.type,
      payload: responseData.data,
    });
  } catch (error) {
    toast.error(error.response.data.message);
    yield put({
      type: apply_coupon_error.type,
    });
  }
}

function* getUserBasketSaga() {
  try {
    const requestRes = yield call(api.get, `/baskets/byuser`);
    const responseData = requestRes.data;
    yield put({
      type: get_user_basket_success.type,
      payload: responseData.data,
    });
  } catch (error) {
    toast.error(error.response.data.message);
    yield put({
      type: get_user_basket_error.type,
    });
  }
}

function* getSingleBasket({ payload }) {
  try {
    const requestRes = yield call(api.get, `/baskets/${payload}`);
    const responseData = requestRes.data;
    yield put({
      type: get_customer_basket_success.type,
      payload: responseData.data,
    });
  } catch (error) {
    toast.error(error.response.data.message);
    yield put({
      type: get_customer_basket_error.type,
    });
  }
}

function* getUserProducts({ payload }) {
  try {
    const requestRes = yield call(api.get, `/basket_products/basket/${payload}`);
    const responseData = requestRes.data;
    yield put({
      type: get_user_products_success.type,
      payload: responseData.data,
    });
  } catch (error) {
    toast.error(error.response.data.message);
    yield put({
      type: get_user_products_error.type,
    });
  }
}

function* deleteProductFromBasketSaga({ payload }) {
  try {
    const requestRes = yield call(api.delete, `/basket_products/${payload}`);
    const responseData = requestRes.data;
    toast.success(responseData.message);
    yield put({
      type: delete_product_from_basket_success.type,
      payload: responseData.data,
    });
  } catch (error) {
    toast.error(error.response.data.message);
    yield put({
      type: delete_product_from_basket_error.type,
    });
  }
}

function* updateProductInBasketSaga({ payload }) {
  try {
    const requestRes = yield call(
      api.patch,
      `/basket_products/${payload.id}`,
      payload.data,
    );

    const responseData = requestRes?.data;

    yield put({
      type: update_basket_quantity_success.type,
      payload: responseData?.data,
    });
  } catch (error) {
    toast.error(error.response.data.message);
    yield put({
      type: update_basket_quantity_error.type,
    });
  }
}

function* getPartnerConfigSagas({ payload }) {
  try {
    const requestRes = yield call(api.get, `/partner_configs/partner/${payload}`);

    const responseData = requestRes?.data;

    yield put({
      type: get_partner_config_success.type,
      payload: responseData?.data,
    });
  } catch (error) {
    toast.error(error.response.data.message);
    yield put({
      type: get_partner_config_error.type,
    });
  }
}

function* getDeliveryLocationSagas({ payload }) {
  try {
    const { id, page = 1 } = payload;
    const requestRes = yield call(
      api.get,
      `/delivery_locations/bypartner/${id}?page=${page}`,
    );

    const responseData = requestRes?.data;

    yield put({
      type: get_delivery_location_success.type,
      payload: responseData?.data,
    });
  } catch (error) {
    toast.error(error.response.data.message);
    yield put({
      type: get_delivery_location_error.type,
    });
  }
}

function* addProductSagas({ payload }) {
  try {
    const request = yield call(api.post, `/basket_products/add_products`, payload);
    const responseData = request.data;
    const response = responseData.data;
    yield put({
      type: add_product_success,
      payload: response,
    });
    localStorage.setItem('basket_id', response.products[0]?.basket?._id);
    const token = localStorage.getItem('x-access-token');

    if (token) {
      localStorage.removeItem('basket');
    }
  } catch (err) {
    console.log(err);
    yield put({
      type: add_product_error.type,
    });
  }
}

function* basketSagas() {
  yield takeLatest(delete_product_from_basket.type, deleteProductFromBasketSaga);
  yield takeEvery(update_basket_quantity.type, updateProductInBasketSaga);
  yield takeEvery(apply_coupon.type, applyCouponSaga);
  yield takeEvery(get_user_basket.type, getUserBasketSaga);
  yield takeEvery(get_user_products.type, getUserProducts);
  yield takeEvery(get_partner_config.type, getPartnerConfigSagas);
  yield takeEvery(get_delivery_location.type, getDeliveryLocationSagas);
  yield takeEvery(get_customer_basket.type, getSingleBasket);
  yield takeEvery(add_product.type, addProductSagas);
}

export default basketSagas;
